<div
  class="canvas-row"
  matRipple
  [class.selected]="isSelected"
  (click)="onSelect()"
  (contextmenu)="onContextMenu($event)"
  (dblclick)="startEditing()"
>
  <mat-icon class="canvas-icon">dashboard</mat-icon>
  @if (isEditing) {
    <input
      #titleInput
      class="canvas-title-input"
      [value]="editTitle"
      (blur)="confirmRename()"
      (click)="$event.stopPropagation()"
      (input)="editTitle = $any($event.target).value"
      (keydown)="onEditKeydown($event)"
    />
  } @else {
    <span class="canvas-title">{{ canvas.title }}</span>
    @if (isDirty) {
      <span class="dirty-indicator" matTooltip="Unsaved changes"></span>
    }
  }
</div>

<!-- Row context menu -->
<div
  #menuTriggerEl
  class="context-menu-trigger"
  [matMenuTriggerFor]="rowContextMenu"
  [style.left.px]="contextMenuPosition.x"
  [style.top.px]="contextMenuPosition.y"
></div>
<mat-menu #rowContextMenu="matMenu" class="canvas-context-menu">
  <button mat-menu-item (click)="onSelect()">
    <mat-icon>open_in_new</mat-icon>
    <span>Open</span>
  </button>
  <button mat-menu-item (click)="onDuplicate()">
    <mat-icon>content_copy</mat-icon>
    <span>Duplicate</span>
  </button>
  <button mat-menu-item (click)="onRename()">
    <mat-icon>edit</mat-icon>
    <span>Rename</span>
  </button>
  <mat-divider></mat-divider>
  <button class="delete-action" mat-menu-item (click)="onDelete()">
    <mat-icon>delete_outline</mat-icon>
    <span>Delete</span>
  </button>
</mat-menu>
